import React from "react"
import { Container, Wrapper, IconWithText } from "./styles/budget"
import { Icon } from "../../components"
import { Container as MainContainer } from "../../containers"
import { calcTime, convertMoney } from "../../helpers/calculate"

export default function BudgerBar({ children, ...rest }) {
  return (
    <Container {...rest}>
      <MainContainer>
        <Wrapper>{children}</Wrapper>
      </MainContainer>
    </Container>
  )
}

BudgerBar.TextWithIcon = function BBTextWithIcon({ icon, text, ...rest }) {
  return (
    <IconWithText {...rest}>
      <Icon name={icon} />
      <p>{text}</p>
    </IconWithText>
  )
}

BudgerBar.Duration = function BBTextWithIcon({ icon, text, ...rest }) {
  return (
    <IconWithText {...rest}>
      <Icon name="ph-clock-bold" />
      <p>Duration: {calcTime(text)}</p>
    </IconWithText>
  )
}

BudgerBar.Budget = function BBTextWithIcon({ icon, text, ...rest }) {
  return (
    <IconWithText {...rest}>
      <Icon name="ph-money-bold" />
      <p>Budget: {convertMoney(text)}</p>
    </IconWithText>
  )
}

BudgerBar.Revenue = function BBTextWithIcon({ icon, text, ...rest }) {
  return (
    <IconWithText {...rest}>
      <Icon name="ph-ticket-bold" />
      <p>Revenue: {convertMoney(text)}</p>
    </IconWithText>
  )
}
